var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-box"},[_c('h1',{staticClass:"chinese-title"},[_vm._v(_vm._s(_vm.chineseTitle))]),_vm._v(" "),_c('h2',{staticClass:"en-title"},[_vm._v(_vm._s(_vm.enTitle))]),_vm._v(" "),_c('h3',{staticClass:"line"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c27fbb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/processTitle.vue
// module id = null
// module chunks = 